export interface Theme {
    mode: string
    colors: {
        brand: string
        primary: string
        white: string
        text: {
            primary: string
            secondary: string
            title: string
            disabled: string
            description: string
        }
        background: string
        darkBackground: string
        error: string
        link: string
        input: {
            label: string
            icon: string
            border: string
            error: string
        }
        card: {
            headerBorder: string
        }
        button: {
            green: string
            label: string
            secondary: string
        }
    }
    gotoSDK: {
        color: {
            background: {
                main: string
                success: string
                secondary: string
            }
            banner: {
                title: string
                description: string
            }
            border: {
                main: string
                primary: string
                secondary: string
            }
            boxShadow: {
                primary: string
            }
            text: {
                primary: string
                secondary: string
                title: string
                description: string
                link: string
            }
        }
        filter: string
    }
    TSEL: {
        color: {
            dark: string
            light: string
            background: {
                main: string
                shimmer: string
                linierStart: string
                linierEnd: string
                linierCenter: string
                gopay: string
                detail: string
            }
            border: {
                main: string
                secondary: string
                dark: string
                light: string
            }
            text: {
                main: string
                secondary: string
                success: string
                gray: string
                title: string
                darkBlue: string
            }
        }
    }
}

const theme: Theme = {
    mode: 'light',
    colors: {
        brand: '#00880D',
        primary: '#2D2E34',
        white: '#FFF',
        text: {
            primary: '#1E2225',
            secondary: '#616E7A',
            title: '#1c1d1d',
            disabled: '#757575',
            description: '#4F515C',
        },
        background: '#FFFFFF',
        darkBackground: '#8b8b8b',
        error: '#F3536B',
        link: '#00AA13',
        input: {
            label: '#494a4a',
            icon: '#ea001f',
            border: '#1c1d1d',
            error: '#C7001B',
        },
        card: {
            headerBorder: '#D8D8D8',
        },
        button: {
            green: '#e0ffe0',
            label: '#00700b',
            secondary: '#bbbbbb',
        },
    },
    gotoSDK: {
        color: {
            background: {
                main: '#F6F6F6',
                success: '#E6FFE8',
                secondary: '#FFFFFF',
            },
            banner: {
                title: '#2D2E34',
                description: '#494A4A',
            },
            border: {
                main: '#D6DFEB',
                primary: '#228B22',
                secondary: 'transparent',
            },
            boxShadow: {
                primary: '0 0 1px 0 rgba(50, 50, 50, 1)',
            },
            text: {
                primary: '#00AA5B',
                secondary: '#999999',
                title: '#212121',
                description: '#5B6271',
                link: '#00AA13',
            },
        },
        filter: 'none',
    },
    TSEL: {
        color: {
            light: '#FFFFFF',
            dark: '#000000',
            background: {
                main: '#ED0226',
                shimmer: '#8B8B8B',
                linierStart: 'rgba(255, 255, 255, 1)',
                linierEnd: 'rgba(253, 110, 100, 0.15)',
                linierCenter: 'rgba(246, 207, 105, 0.25)',
                gopay: '#02AFD9',
                detail: 'rgba(237, 2, 38, 0.05)',
            },
            border: {
                main: '#E2E5E9',
                secondary: '#DAE0E9',
                dark: '#9CA9B9',
                light: '#EFF1F4',
            },
            text: {
                main: '#ED0226',
                secondary: '#757F90',
                success: '#008E53',
                gray: '#9CA9B9',
                title: '#181C21',
                darkBlue: '#001A41',
            },
        },
    },
}

export default theme
